import FormField from '@berlitz/form-field'
import { spaceXxss } from '@utils/constants'
import { _placeholder } from '@utils/mixins'
import { AutoComplete, Input } from 'antd'
import 'antd/lib/auto-complete/style/index.css'
import 'antd/lib/input/style/index.css'
import 'antd/lib/select/style/index.css'
import styled, { css } from 'styled-components'

interface FieldProps {
  disableMargin: boolean
}

export const Field = styled(FormField)<FieldProps>`
  label {
    font-weight: ${({ theme }) => theme.fontWeight.bold};
    font-size: ${({ theme }) => theme.fontSize.xxs};
    margin-bottom: ${({ theme }) => theme.space.xs};
  }

  ${({ disableMargin }) =>
    disableMargin &&
    css`
      margin-bottom: 0;
      padding-bottom: 0;
    `}
`

export const StyledInput = styled(Input)`
  .ant-select-selection__placeholder,
  input {
    font-size: ${({ theme }) => theme.fontSize.xs};
    font-weight: ${({ theme }) => theme.fontWeight.regular};
    padding: ${({ theme }) => `${theme.space.xs} ${theme.space.lg} ${theme.space.xs} ${spaceXxss}`};
    border: solid 1px ${({ theme }) => theme.palette.gray100};
    border-radius: ${({ theme }) => theme.radius.sm};
    height: 36px !important;
    ${_placeholder(css`
      font-weight: ${({ theme }) => theme.fontWeight.regular};
      color: ${({ theme }) => theme.colors.brandSecondaryContrast};
      font-size: ${({ theme }) => theme.fontSize.xs};
    `)}
  }
`

export const StyledAutoComplete = styled(AutoComplete)`
  width: 100%;
  .ant-select-selection__placeholder {
    font-size: ${({ theme }) => theme.fontSize.xs};
    font-weight: ${({ theme }) => theme.fontWeight.regular};
    color: ${({ theme }) => theme.colors.brandSecondaryContrast};
    margin-left: ${spaceXxss};
  }

  .ant-select-selection__clear {
    background: ${({ theme }) => theme.colors.brandPrimaryContrast};
    right: 12px;
    width: 15px;
    height: 15px;
  }
  .ant-input-suffix {
    height: 34px;
    width: ${({ theme }) => theme.space.xxl};
    right: 0;
    text-align: center;
    padding: ${({ theme }) => theme.space.sm};
    background: ${({ theme }) => theme.colors.brandPrimary};
    color: ${({ theme }) => theme.colors.brandPrimaryContrast};
    font-size: ${({ theme }) => theme.fontSize.sm};
  }
  .ant-input-affix-wrapper .ant-input:not(:last-child) {
    padding-right: ${({ theme }) => theme.space.xxl};
  }
`
